import useSWR from "swr"

import {
    AppError,
    parseAndThrowAppError,
} from "../../../../errors/errorProcessors"
import {
    badRequestError,
    invalidApiDataError,
} from "../../../../errors/recognisedErrors"
import { getClientProtected } from "../../clients/clients"
import { sysAdminHomepageMapper } from "../../mappers/sysAdminInterface/sysAdminHomepageMapper"
import { ISysAdminDevicesData } from "../../types/sysAdminInterface/sysAdminHomepageTypes"
import { ENA_SYS_ADMIN_REPORTING } from "../../urls/private"

interface ISysAdminHomepageData {
    data: ISysAdminDevicesData | undefined
    error: AppError | null
    isLoading: boolean
}

/**
 * Hook to get the SysAdmin homepage data
 * @returns The SysAdmin homepage data
 */
const useGetSysAdminHomepageData = (): ISysAdminHomepageData => {
    const { data, error, isLoading } = useSWR(
        ENA_SYS_ADMIN_REPORTING,
        async (url: string): Promise<ISysAdminDevicesData> => {
            try {
                const res = await getClientProtected(url)
                return sysAdminHomepageMapper.mapSysAdminDevicesData(res)
            } catch (err) {
                badRequestError("Failed to load KPI's")
                const appError = parseAndThrowAppError(err)
                throw invalidApiDataError(appError.message)
            }
        }
    )
    return {
        data,
        error,
        isLoading,
    }
}

export { useGetSysAdminHomepageData }
